import { forwardRef } from 'react'

import { styled } from 'styled-components'

const Item = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  transition: border-color 0s, background-color 0.1s;
  margin-bottom: 4px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: ${(p) => (p.isSelected ? p.theme.banner : 'transparent')};
  cursor: pointer;
  padding: ${(p) => (p.hasNote ? '6px' : '8px')} 8px;
  width: 100%;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }

  &:disabled {
    cursor: default;
  }

  &:not(:disabled) :hover {
    background-color: ${(p) => p.theme.hover};
  }
`

const Left = styled.span`
  padding-right: 8px;
`

const Label = styled.div`
  flex-grow: 1;
`

const Right = styled.span`
  padding-left: 8px;
`

const LabelText = styled.div`
  opacity: ${(p) => (p.disabled ? '0.25' : '1')};
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
  color: ${(p) => p.theme.text};
`

const Note = styled.div`
  opacity: ${(p) => (p.disabled ? '0.25' : '1')};
  padding-top: 6px;
  color: ${(p) => p.theme.mutedText};
  font-size: 12px;
`

const SelectItem = forwardRef((props, ref) => {
  const { isSelected, onClick, left, right, label, note, disabled } = props

  return (
    <Item
      onClick={onClick}
      isSelected={isSelected}
      disabled={disabled}
      hasNote={!!note}
    >
      {left && <Left>{left}</Left>}
      <Label>
        <LabelText disabled={disabled}>{label}</LabelText>
        {note && <Note disabled={disabled}>{note}</Note>}
      </Label>
      {right && <Right>{right}</Right>}
    </Item>
  )
})

export default SelectItem
